<template>
  <div class="mobile-index">
    <div class="search-panel" v-if="showpan">
      <the-header-search show-cancel></the-header-search>
      <div>经度：{{lng}} 纬度：{{lat}}</div>
    </div>
    <transition name="nav-panel">
      <div class="nav-panel" v-show="showSidebarNav">
        <the-nav :data="navigationData"
                 isMobileMode
                 @start="startTrip"
                 @clear="clearTrip"
                 @cancel-nav="cancelNav"></the-nav>
      </div>
    </transition>
    <div class="map-container">
      <the-map :data="mapData"
               ref="map"
               :showInfoWin="false"
               @selectMarker="selectMarker"
               @showNav="showNav"></the-map>
    </div>
    <div class="enter-panel" :style="heightStyle" ref="drawer" :class="{ active: isEnterFull, 'detail-mode': currentHall || sidebarStatus === 'DETAIL', 'contain-filter': !currentHall && sidebarStatus === 'DETAIL' && currentSubject && currentSubject.code === '1-1' }">
      <div class="panel-toggle "></div>
      <div class="panel-header"   catchtouchmove="true">
        <template v-if="isNaving">
          <div class="header-main">
            <div class="area-select">路线详情</div>
            <i class="close-detail ri-close-circle-fill"
               @click="clearTrip"></i>
          </div>
        </template>
        <template v-else-if="currentHall">
          <div class="header-main">
            <div class="area-select">{{ currentHall.name }}</div>
            <i class="close-detail ri-close-circle-fill"
               @click="cancelHall"></i>
          </div>
        </template>
        <template v-else-if="sidebarStatus === 'NEARBY' || sidebarStatus === 'SUBJECT'">
          <div class="header-main">
            <div class="area-select"
                 @click="showAreaPicker = true">{{ currentArea.name }}<i class="ri-arrow-down-s-fill"></i></div>
            <span class="panel-tip">
            <template v-if="!isEnterFull">向上拉起，发现更多</template>
            <template v-else>向下划动，畅享地图</template>
            </span>
          </div>
        </template>
        <template v-else-if="sidebarStatus === 'DETAIL'">
          <div class="header-main">
            <div class="area-select">{{ detailHeaderName }}</div>
            <i class="close-detail ri-close-circle-fill"
               @click="cancelSearch('')"></i>
          </div>
          <!-- 大厅类型使用筛选组件 -->
          <hall-filter v-if="currentSubject && currentSubject.code === '1-1'" isMobileMode  @changeFilter="filterSearch"></hall-filter>
        </template>
      </div>
      <div class="panel-body" @scroll.passive="onListScrolled($event)">
        <div v-show="!currentHall && (sidebarStatus === 'NEARBY' || sidebarStatus === 'SUBJECT')&& !isNaving">
          <transition name="sidebar">
            <!-- 默认列表 -->
            <hall-list
              v-infinite-scroll="getHallList"
              v-loading="listLoading"
              infinite-scroll-immediate = false
              :infinite-scroll-disabled="listLoading || noMore"
              :data="handleHallList(hallList)"
              prefix="d"
              v-show="sidebarStatus === 'NEARBY'"
              @selectHall="selectHall"
               @cancelBar="can"
               @show-nav="showNav"
              @active="active"></hall-list>
          </transition>
          <transition name="sidebar">
            <subject-list v-show="sidebarStatus === 'SUBJECT'"
                          :data="subjectList"
                          @selectSubject="selectSubject"></subject-list>
          </transition>
        </div>
        <div v-show="!currentHall && sidebarStatus === 'DETAIL'&& !isNaving">
          <transition name="sidebar">
            <div v-if="currentDetailList.length">
              <!-- 列表组件除事项类型外，统一使用大厅列表组件 -->
              <el-collapse
                  class="item-list"
                  v-if="searchType && searchType === 'ITEM'">
                <el-collapse-item
                  v-for="(item, index) in currentDetailList"
                  :key="index + item.ID"
                  @click.native="getItemInfoByItemCode(item)">
                  <template slot="title">
                    <div class="item-title">
                      <div>{{ item.NAME }}</div>
                    </div>
                  </template>
                  <div class="no-hall" v-if="item.guideLoading">正在加载区划和部门信息</div>
                  <div class="no-hall" v-else>选择区划和部门查看大厅信息：</div>
                  <div class="condition-wrap">
                    
                    <el-tooltip class="item" effect="light" content="输入区划名称搜索" placement="right">
                      <el-select
                        v-model="item.region"
                        placeholder="请选择区划"
                        filterable
                        @change="val => changeHallRegion(item, val)"
                        :disabled="item.guideLoading">
                        <el-option
                          v-for="r in item.regionList"
                          :key="r.value"
                          :label="r.label"
                          :value="r.value">
                        </el-option>
                      </el-select>
                    </el-tooltip>
                    <el-select
                      ref="departSelect"
                      v-model="item.depart"
                      placeholder="请选择部门"
                      @change="getPriorProjectListByItemCode(item, true)"
                      :disabled="item.guideLoading">
                      <el-option
                        v-for="d in item.region ? item.departList.filter(u => item.region ? item.region == u.code : true ) : []"
                        :key="d.value"
                        :label="d.label"
                        :value="d.value">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="btn-wrap" >
                    <el-button type="primary" plain
                      @click="getGuideBasicInfo(item)"
                      :loading="item.guideLoading"
                      :disabled="item.guideLoading || !currentMatter"
                    >办事指南</el-button>
                  </div>
                  <div class="no-hall" v-if="item.hallLoading && !item.hallList.length">正在加载大厅数据...</div>
                  <div class="no-hall" v-if="!item.hallLoading && !item.hallList.length">暂无大厅数据</div>
                   <hall-list :data="item.hallList.filter(h => !item.region || h.regionCode == item.region) || []"
                               @selectHall="selectItemHall($event, item)"
                               :item-info="item"
                               isMobileMode
                               :itemCode="currentItem"
                               @show-nav="showNav"
                               @showAppointment1="showAppointment1"
                               ></hall-list>
                </el-collapse-item>
              </el-collapse>
              <!-- 搜索结果 -->
              <hall-list v-else
                v-infinite-scroll="searchHallList"
                v-loading="listLoadingSearch"
                infinite-scroll-immediate = false
                :infinite-scroll-disabled="listLoadingSearch || noMoreSearch"
                :data="currentDetailList"
                prefix="s"
                @selectHall="selectHall"
                @cancelBar="can"
                @active="active"></hall-list>
            </div>
            <no-data v-else v-loading="listLoadingSearch">
              <div class="tip-title">您可以：</div>
              <div class="tip-info">1.在<span @click="cancelSearch('NEARBY')">附近大厅</span>查找结果；</div>
              <div class="tip-info">2.在<span @click="cancelSearch('SUBJECT')">全部专题</span>查找结果。</div>
            </no-data>
          </transition>
        </div>
        <div v-show="currentHall && !isNaving" style="width: 100%;height: 100%;">
          <transition name="hall-panel">
            <the-hallbar ref="hallBar"
                         :data="currentHall"
                         :itemCode="currentItem"
                         isMobileMode
                          @showNav="showNav"
                         @cancel-bar="cancelHall"
                         @show-nav="showNav"></the-hallbar>
          </transition>
        </div>
        <div v-show="!currentHall || isNaving">
          <div id="map-panel"></div>
        </div>
         <!-- <div v-show="currentHall && !isNaving" style="width: 100%;height: 100%;">
          <transition name="hall-panel">
            <the-halllist ref="hallBar"
                         :data="currentHall"
                         :itemCode="currentItem"
                         isMobileMode
                         @cancel-bar="cancelHall"
                         @show-nav="showNav"></the-halllist>
          </transition>
        </div> -->
      </div>
    </div>
    <van-tabbar v-model="sidebarStatus">
      <van-tabbar-item name="NEARBY">
        <template #icon>
          <i class="ri-bank-fill"></i>
        </template>
        <span>附近大厅</span>
      </van-tabbar-item>
      <van-tabbar-item name="SUBJECT">
        <template #icon>
          <i class="ri-honour-fill"></i>
        </template>
        <span>专题服务</span>
      </van-tabbar-item>
    </van-tabbar>
    <van-popup v-model="showAreaPicker" round position="bottom">
      <van-picker show-toolbar
                  title="区域选择"
                  :columns="areaList"
                  value-key="name"
                  @confirm="confirmArea"
                  @cancel="showAreaPicker = false"/>
    </van-popup>
    <van-popup
      v-model="showBusinessGuide"
      position="top"
      closeable>
      <BusinessGuide
      :item-data="currentMatter"
      :is-mobile-mode="true"
      ></BusinessGuide>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import Bus from "@/api/bus";
import { Tabbar, TabbarItem, Popup, Picker } from "vant";
import Vue2TouchEvents from "vue2-touch-events";
import { configArea } from "@/config/system";
import { mapGetters } from "vuex";
import hallMixins from "@/mixins/hallMixins";
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Vue2TouchEvents);
export default {
  name: "MobileIndex",
  mixins: [hallMixins],
  components: {
    TheMap: () => import("@comp/TheMap"),
    TheNav: () => import("@comp/TheNav"),
    TheHeaderSearch: () => import("@comp/TheHeaderSearch"),
    TheHallbar: () => import("@comp/TheHallbar"),
    HallList: () => import("@comp/HallList"),
    HallFilter: () => import("@comp/HallFilter"),
    SubjectList: () => import("@comp/SubjectList"),
    NoData: () => import("@comp/NoData"),
    BusinessGuide: () => import("@comp/BusinessGuide")
  },
  data() {
    return {
      showpan: true,
      isToped: true, //判断列表的第一个元素是否位于顶部
      isScollToTop: true, //true 向顶部滑动
      defaultHeight: 39, //记录默认高度 %
      currentHeight: 39, //记录当前窗体高度%
      window: {
        startHeight: 39,
        endHeight: 82
      },
      startPos: {
        y: 0
      },
      endPos: {
        y: 0
      },
      // 侧边栏当前状态：'NEARBY'：附近大厅；'SUBJECT'：全部专题；'DETAIL'：专题/搜索列表
      sidebarStatus: "NEARBY",
      // 显示导航面板
      showSidebarNav: false,
      // 显示切换区域选择器
      showAreaPicker: false,
      // 区域列表
      areaList: configArea,
      // 展开主题面板
      isEnterFull: false,
      // 前序状态
      prevStatus: null,
      // 导航数据
      navigationData: {},
      swiper: null,
      showBusinessGuide: false
    };
  },
  computed: {
    ...mapGetters(["currentArea", "geoLocation"]),
    heightStyle() {
      return {
        height: this.currentHeight + "%"
      };
    },
    lat() {
      return this.geoLocation[1];
    },
    lng() {
      return this.geoLocation[0];
    }
  },
  mounted() {
    const that = this;
    that.mapData = that.handleHallList(that.hallList);
    this.handleTounchListener();
    Bus.$on("val", data => {
      console.log("index", data);
      that.showpan = data;
    });
    let { trustticket } = this.$route.query;
    console.log("trustticket", trustticket);
    if (trustticket) {
      this.$store.dispatch("getUserInfo", trustticket);
    }
  },
  methods: {
    openDrawable() {
      // 60Hz, 16.6ms
      let id = setInterval(() => {
        if (this.isScollToTop) {
          this.isScollToTop = false;
          this.currentHeight = this.window.endHeight;
          clearInterval(id);
        } else {
          this.currentHeight = this.window.startHeight;
          this.isScollToTop = true;
          clearInterval(id);
        }
      }, 10);
    },
    onListScrolled(event) {
      let top = event.target.scrollTop;
      this.isToped = top === 0;
    },
    handleTounchListener() {
      this.$refs.drawer.addEventListener("touchstart", event => {
        //记录点击坐标
        this.startPos.y = event.targetTouches[0].pageY;
        this.defaultHeight = this.currentHeight;
      });
      this.$refs.drawer.addEventListener("touchmove", event => {
        //计算移动距离
        if (event.targetTouches.length > 1) {
          return;
        }
        let touch = event.targetTouches[0];
        let dy = (this.startPos.y - touch.pageY) * 100 / 667;

        if (this.isToped && !this.isScollToTop && dy < 0) {
          this.endPos.y = touch.pageY;
          this.currentHeight = Math.max(
            this.window.startHeight,
            this.defaultHeight + dy
          );
          console.log(this.currentHeight);
          event.preventDefault();
        } else if (this.isToped && dy > 0 && this.isScollToTop) {
          //向上
          event.preventDefault();
          this.endPos.y = touch.pageY;
          this.currentHeight = Math.min(
            this.window.endHeight,
            this.defaultHeight + dy
          );
          console.log(this.currentHeight);
        }
      });
      this.$refs.drawer.addEventListener("touchend", event => {
        console.log("====touchend======", event);
        // 阈值 = 差值的20%
        const threshold =
          Math.abs(this.defaultHeight - this.currentHeight) * 0.2;
        if (!this.isToped || threshold === 0) {
          return;
        }
        const scrollDy = Math.abs(this.endPos.y - this.startPos.y);
        const isDirectorTop = this.endPos.y - this.startPos.y < 0;
        const isToTop =
          (isDirectorTop && scrollDy > threshold) ||
          (!isDirectorTop && scrollDy < threshold);

        // 60Hz, 16.6ms
        let id = setInterval(() => {
          if (isToTop) {
            this.isScollToTop = false;
            this.currentHeight = this.window.endHeight;
            clearInterval(id);
          } else {
            this.currentHeight = this.window.startHeight;
            this.isScollToTop = true;
            clearInterval(id);
          }
        }, 10);
      });
      this.$refs.drawer.addEventListener("touchcancel", event => {
        console.log("=====touchcancel=====", event);
      });
    },
    // 切换区域
    confirmArea(value) {
      const that = this;
      that.showAreaPicker = false;
      that.$store.commit("setCurrentArea", value);
    },
    swipeHandler(direction) {
      const that = this;
      if (direction === "top") {
        that.isEnterFull = true;
      } else if (direction === "bottom") {
        that.isEnterFull = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@style/_var.scss";
@import "~@style/_theme.scss";
.mobile-index {
  width: 100%;
  height: 100%;
  $tabbarHeight: 56px;
  $enterPanelHeight: 212px;
  .map-container {
    position: relative;
    width: 100%;
    height: 100%;
    padding-bottom: $enterPanelHeight;
    z-index: 0;
  }
  ::v-deep .van-tabbar {
    height: $tabbarHeight;
    background: #fff;
    box-shadow: 0 1px 10px 0 #d2dbe7;
    border-radius: 10px 10px 0 0;
    .van-tabbar-item {
      align-items: center;
      flex-direction: row;
      font-size: 16px;
      color: $colorTextRegular;
      transition: $transitionTime;
      .van-tabbar-item__icon {
        margin-bottom: 0;
        margin-right: 8px;
        transition: $transitionTime;
      }
      &.van-tabbar-item--active {
        color: $colorPrimary;
        background-color: transparent;
        .van-tabbar-item__icon {
          text-shadow: 3px 3px 3px rgba(147, 174, 215, 0.5);
        }
      }
    }
  }
  .enter-panel {
    $panelHeaderHeight: 50px;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: $enterPanelHeight;
    padding-top: $panelHeaderHeight;
    padding-bottom: $tabbarHeight;
    background: $sidebarBgColor;
    box-shadow: 0 1px 10px 0 #d2dbe7;
    border-radius: 10px 10px 0 0;
    transition: $transitionTime;
    overflow-x: hidden;
    &.active {
      height: auto;
      top: 160px;
    }
    &.detail-mode {
      z-index: 4;
      padding-bottom: 0;
    }
    &.contain-filter {
      padding-top: $panelHeaderHeight + 49px;
      .panel-header {
        height: $panelHeaderHeight + 49px;
      }
    }
    .panel-toggle {
      position: absolute;
      z-index: 2;
      left: 0;
      right: 0;
      top: 8px;
      width: 90px;
      height: 6px;
      margin: 0 auto 8px;
      background: #000;
      border-radius: 4px;
      opacity: 0.3;
      &:hover {
        opacity: 0.6;
      }
    }
    .panel-header {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      background-color: #fff;
      .header-main {
        width: 100%;
        height: $panelHeaderHeight;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 $paddingHorizontal;
      }
      .close-detail {
        font-size: 20px;
        color: $colorTextSecondary;
        &:hover {
          color: $colorTextRegular;
        }
      }
    }
    .panel-body {
      position: relative;
      width: 100%;
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;
    }
    .area-select {
      font-size: 16px;
      font-weight: 500;
      color: $colorTextPrimary;
      margin-top: 10px;
      i {
        margin-left: 8px;
      }
    }
    .panel-tip {
      font-size: 12px;
      color: $colorTextSecondary;
    }
    ::v-deep .subject-list .sub-group-title {
      margin-bottom: 0;
    }
    ::v-deep .sub-list {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      padding: 0;
      .sub-item {
        float: none;
        width: 25%;
        margin-bottom: 0;
      }
    }
  }
  ::v-deep .no-data {
    padding-top: 0;
    img {
      width: 240px;
      margin-bottom: 0;
    }
    .tip-title {
      padding-top: 8px;
    }
  }
  ::v-deep .van-dropdown-menu {
    width: 100%;
  }
}
.search-panel {
  $panelHeight: 48px;
  position: fixed;
  z-index: 12;
  left: $paddingHorizontal;
  right: $paddingHorizontal;
  top: $paddingVertical;
  height: $panelHeight;
  background: #fff;
  box-shadow: 0 1px 10px 0 #d2dbe7;
  border-radius: 8px;
  ::v-deep .the-header-search {
    display: block;
    width: 100%;
    height: 100%;
    margin-left: 0;
    .search-panel {
      position: fixed;
      z-index: 9;
      left: 0;
      right: 0;
      top: $panelHeight + 16px;
      bottom: 0;
      width: 100%;
      padding-bottom: 16px;
      box-shadow: 0 1px 10px 0 #d2dbe7;
      border-radius: 10px 10px 0 0;
      &:before {
        display: none;
      }
      .mobile-info {
        display: none;
      }
      .panel-title {
        font-size: 16px;
      }
    }
    .el-select {
      .el-input__inner {
        height: $panelHeight;
        line-height: $panelHeight;
        color: $colorTextRegular;
      }
      .el-input__icon {
        line-height: $panelHeight;
        color: $colorTextSecondary;
        font-family: remixicon !important;
        transform-origin: center;
        &:before {
          content: "\EA77";
        }
      }
    }
    .search-input {
      &:before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 1px;
        height: 16px;
        margin: auto 0;
        background-color: #adadad;
      }
    }
    .search-input .el-input__inner {
      height: $panelHeight;
      line-height: $panelHeight;
      color: $colorTextRegular;
    }
    .search-icon {
      height: $panelHeight;
      line-height: $panelHeight;
      color: $colorTextRegular;
    }
    .cancel-search {
      height: $panelHeight;
      line-height: $panelHeight;
      color: $colorPrimary;
    }
  }
}
.nav-panel {
  position: fixed;
  z-index: 13;
  top: 0;
  left: 0;
  right: 0;
  background: #fff;
  box-shadow: 0 1px 10px 0 #d2dbe7;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}
.tip-title {
  padding-top: 24px;
  margin-bottom: 8px;
  font-size: 16px;
}
.tip-info {
  span {
    margin: 0 4px;
    color: $colorPrimary;
    cursor: pointer;
    text-decoration: underline;
  }
}

/* hall-panel transition */
.hall-panel-enter-active {
  transition: all 0.5s;
}

.hall-panel-enter,
.hall-panel-leave-active {
  opacity: 0;
  transform: translateY(32px);
}

.hall-panel-move {
  transition: all 0.5s;
}

.hall-panel-leave-active {
  position: absolute;
  transition: all 0.5s;
}
/* nav-panel transition */
.nav-panel-enter-active {
  transition: all 0.5s;
}

.nav-panel-enter,
.nav-panel-leave-active {
  opacity: 0;
  transform: translateY(-32px);
}

.nav-panel-move {
  transition: all 0.5s;
}

.nav-panel-leave-active {
  position: absolute;
  transition: all 0.5s;
}
.view-more {
  padding: 8px 0;
  text-align: center;
  span {
    cursor: pointer;
    &:hover {
      color: $colorPrimary;
    }
  }
  i {
    width: 18px;
    height: 18px;
    margin-left: 4px;
    text-align: center;
    line-height: 18px;
    color: $colorPrimary;
    background: $colorPrimaryLighten;
    vertical-align: -3px;
    border-radius: 50%;
  }
}

::v-deep .el-tabs__content {
  overflow-x: auto;
  height: 100%;

  table {
    min-width: 1300px;
    zoom: 0.8;
  }
}

.item-list {
  .btn-wrap {
    padding: 0 16px 14px;

    button {
      display: block;
      width: 100%;
    }
  }
}

.condition-wrap {
  display: flex;
  padding: 0 16px 10px;

  & > * {
    &:nth-child(1) {
      width: 46%;
    }
  }
}

.no-hall {
  padding: 0 16px 10px;
  color: #999;
}
</style>
